'use client'
import { TermsUpdateAckDialog } from './TermsUpdateAckDialog'
import { useTermsUpdateAck } from './useTermsUpdateAck'

export const TermsUpdateAckGate = () => {
  const { open, error, isSaving, handleGotIt } = useTermsUpdateAck()
  return (
    <TermsUpdateAckDialog
      open={open}
      onGotIt={handleGotIt}
      error={error}
      isSaving={isSaving}
    />
  )
}
